const MATRIZ_EXPOSICAO_PRIORIDADE = {
  ALTA: 'ALTA',
  MEDIA: 'MEDIA',
  BAIXA: 'BAIXA',
  NULA: 'NULA',
};

export default MATRIZ_EXPOSICAO_PRIORIDADE;
